import styled from 'styled-components';

export const ContainerNotes = styled.div`
  width: 100%;
  height: 100%;
`;
